module.exports = __webpack_public_path__ + "img/map_splash_image.8904cd07.png";